import { render, staticRenderFns } from "./lazyblock_last_posts.vue?vue&type=template&id=77b26695&scoped=true"
import script from "./lazyblock_last_posts.vue?vue&type=script&lang=js"
export * from "./lazyblock_last_posts.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_last_posts.vue?vue&type=style&index=0&id=77b26695&prod&lang=scss&scoped=true"
import style1 from "./lazyblock_last_posts.vue?vue&type=style&index=1&id=77b26695&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b26695",
  null
  
)

export default component.exports